import { render, staticRenderFns } from "./StudentstatisticsNoSubordinate.vue?vue&type=template&id=834185c2"
import script from "./StudentstatisticsNoSubordinate.vue?vue&type=script&lang=js"
export * from "./StudentstatisticsNoSubordinate.vue?vue&type=script&lang=js"
import style0 from "./StudentstatisticsNoSubordinate.vue?vue&type=style&index=0&id=834185c2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports